export default "__VITE_ASSET__4662a45d__"